import { Box, Toolbar, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { DataLoader } from "../DataLoader";

export const AppMainContent: React.FC<{ isMobile?: boolean }> = ({
  isMobile = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: "100vh",
        overflowY: "hidden",
        bgcolor: theme.palette.background.default,
        p: { xs: 1.5, md: 4 },
        mt: isMobile ? 6 : 0,
      }}
    >
      {isMobile && <Toolbar sx={{ minHeight: 0 }} />}
      <Box
        id="workarea"
        sx={{ overflow: "auto", flex: 1, position: "relative" }}
      >
        <DataLoader>
          <Outlet />
        </DataLoader>
      </Box>
    </Box>
  );
};
